import { render, staticRenderFns } from "./TripAddresses.vue?vue&type=template&id=1c7c89c8&scoped=true&"
import script from "./TripAddresses.vue?vue&type=script&lang=js&"
export * from "./TripAddresses.vue?vue&type=script&lang=js&"
import style0 from "./TripAddresses.vue?vue&type=style&index=0&id=1c7c89c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7c89c8",
  null
  
)

/* custom blocks */
import block0 from "./TripAddresses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports